import { Alert, AlertIcon, Box, Center, Spinner } from '@chakra-ui/react';
import { useTiledeskDashboardAccess } from '@partiu/api/tiledesk/hooks.ts';
import { HEADER_HEIGHT } from '@partiu/ui/components/organisms/TopMenuDash.tsx';

/**
 * Painel do Tiledesk do convênio embutido, já logado como admin do projeto:
 * o ISP atende, cria atendentes e configura o widget sem sair do dashboard.
 */
export function SupportChatPage() {
  const { data, isLoading, isError } = useTiledeskDashboardAccess(true);

  if (isLoading) {
    return (
      <Center width="100%" height="50vh">
        <Spinner />
      </Center>
    );
  }

  if (isError || !data?.url) {
    return (
      <Box width="100%" padding={4}>
        <Alert status="warning">
          <AlertIcon />
          Chat de suporte não está ativo para este convênio.
        </Alert>
      </Box>
    );
  }

  return (
    <Box
      as="iframe"
      title="Chat de Suporte"
      src={data.url}
      allow="clipboard-read; clipboard-write; microphone; camera; autoplay; notifications"
      width="100%"
      height={`calc(100vh - ${HEADER_HEIGHT})`}
      border={0}
    />
  );
}
